var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5708 16.7475C16.3783 15.9888 17.0216 15.0725 17.461 14.0552C17.9003 13.038 18.1263 11.9414 18.125 10.8334C18.125 6.34587 14.4875 2.70837 10 2.70837C5.51251 2.70837 1.87501 6.34587 1.87501 10.8334C1.87372 11.9414 2.09973 13.038 2.53905 14.0552C2.97837 15.0725 3.62166 15.9888 4.42917 16.7475C5.93495 18.17 7.92863 18.9612 10 18.9584C12.0714 18.9612 14.0651 18.17 15.5708 16.7475ZM5.12084 15.6767C5.7059 14.9447 6.44835 14.354 7.29304 13.9483C8.13772 13.5426 9.06295 13.3324 10 13.3334C10.9371 13.3324 11.8623 13.5426 12.707 13.9483C13.5517 14.354 14.2941 14.9447 14.8792 15.6767C14.2409 16.3215 13.4809 16.833 12.6433 17.1818C11.8058 17.5306 10.9073 17.7095 10 17.7084C9.09273 17.7095 8.19426 17.5306 7.35669 17.1818C6.51913 16.833 5.75915 16.3215 5.12084 15.6767ZM13.125 8.33337C13.125 9.16218 12.7958 9.95703 12.2097 10.5431C11.6237 11.1291 10.8288 11.4584 10 11.4584C9.1712 11.4584 8.37635 11.1291 7.7903 10.5431C7.20425 9.95703 6.87501 9.16218 6.87501 8.33337C6.87501 7.50457 7.20425 6.70972 7.7903 6.12367C8.37635 5.53761 9.1712 5.20837 10 5.20837C10.8288 5.20837 11.6237 5.53761 12.2097 6.12367C12.7958 6.70972 13.125 7.50457 13.125 8.33337Z",
    fill: "#000E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.796f6effc625a2d0d6ab0d072bd40f58.svg";
export { ForwardRef as ReactComponent };